export default __webpack_public_path__ + "static/media/cfs.fac90104.webp";